import { Component } from '@angular/core';

@Component({
    selector: 'app-signup-host',
    templateUrl: './signup-host.component.html',
    styleUrls: ['./signup-host.component.scss'],
    standalone: false
})
export class SignupHostComponent {

  constructor() { }

}
